import api from '../../../config/axios'

export interface CertificateResponse {
  id: string
  result_id: string
  certificate_number: string | null
  /** Download filename from document_url (after certificates/); use for download. */
  filename?: string | null
  is_active: boolean
  created_by: string
  created_date: string
}

export interface CertificateGenerateRequest {
  result_id: string
  date?: string
  temperature?: string
  humidity?: string
  atm_pressure?: string
  cable_length?: string
  dwt_no?: string
  change_reason_id?: string
}

export interface CertificateChangeReason {
  id: string
  reason: string
  is_active: boolean
}

export const certificateService = {
  getChangeReasons: () =>
    api.get<CertificateChangeReason[]>('/certificates/change-reasons').then((res) => res.data),

  getByResultId: (resultId: string) =>
    api
      .get<CertificateResponse[]>('/certificates', {
        params: { result_id: resultId, limit: 1 },
      })
      .then((res) => res.data),

  generate: (body: CertificateGenerateRequest) =>
    api.post<CertificateResponse>('/certificates/generate', body).then((res) => res.data),

  preview: (body: CertificateGenerateRequest) =>
    api.post<string | { html?: string }>('/certificates/preview', body).then((res) =>
      typeof res.data === 'string' ? res.data : res.data.html ?? ''
    ),

  /**
   * Fetch certificate PDF as blob (uses auth). Use with triggerCertificateDownload().
   */
  getDownloadBlob: (certificateId: string) =>
    api.get(`/certificates/${certificateId}/download`, { responseType: 'blob' }).then((res) => res.data as Blob),

  /**
   * Trigger browser download of a certificate PDF blob.
   */
  triggerCertificateDownload: (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename.endsWith('.pdf') ? filename : `${filename}.pdf`
    a.click()
    URL.revokeObjectURL(url)
  },
}
